const millisecondsForNextItem = 10_000;
let autoAdvanceTimer = null;
document.addEventListener("DOMContentLoaded", function () {
    const items = document.querySelectorAll(".carousel-item");
    const prevButton = document.getElementById("prev-video");
    const nextButton = document.getElementById("next-video");
    const soundButton = document.getElementById("toggle-sound");
    let currentIndex = 0;
    function clearTimer() {
        if (autoAdvanceTimer) {
            clearTimeout(autoAdvanceTimer);
            autoAdvanceTimer = null;
        }
    }
    function unloadAll() {
        items.forEach((item) => {
            item.style.display = "none";
            if (item.tagName === "VIDEO") {
                item.pause();
                item.currentTime = 0;
            }
        });
    }
    function loadItem() {
        clearTimer();
        unloadAll();
        const item = items[currentIndex];
        item.style.display = "block";
        if (item.tagName === "VIDEO") {
            item.play().catch(e => console.log("Autoplay bloqueado:", e));
            autoAdvanceTimer = setTimeout(nextItem, millisecondsForNextItem);
        } else if (item.tagName === "IMG") {
            autoAdvanceTimer = setTimeout(nextItem, millisecondsForNextItem);
        }
        
        handleHasSound();
    }

    function nextItem() {
        currentIndex = (currentIndex + 1) % items.length;
        loadItem();
    }
    function prevItem() {
        currentIndex = (currentIndex - 1 + items.length) % items.length;
        loadItem();
    }
    function handleItemEvents(item) {
        if (item.tagName === "VIDEO") {
            item.removeEventListener("ended", nextItem); 
            item.addEventListener("ended", nextItem);
        }
        const link = item.getAttribute("data-link");
        if (link) {
            item.style.cursor = "pointer";
            item.addEventListener("click", () => window.open(link, "_blank"));
        }
    }

    function handleSwipe() {
        if (touchEndX < touchStartX - 50) nextItem();
        if (touchEndX > touchStartX + 50) prevItem();
    }

    function toggleSound() {
        const currentVideo = items[currentIndex];
        currentVideo.muted = !currentVideo.muted;
        currentVideo.volume = currentVideo.muted ? 0 : .2;
        handleHasSound();
    }

    function handleHasSound() {
        const currentVideo = items[currentIndex];
        if (currentVideo.muted) {
            soundButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-x"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><line x1="23" y1="9" x2="17" y2="15"></line><line x1="17" y1="9" x2="23" y2="15"></line></svg>';
        } else {
            soundButton.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="feather feather-volume-2"><polygon points="11 5 6 9 2 9 2 15 6 15 11 19 11 5"></polygon><path d="M19.07 4.93a10 10 0 0 1 0 14.14M15.54 8.46a5 5 0 0 1 0 7.07"></path></svg>';
        }
    }

    let touchStartX = 0;
    let touchEndX = 0;
    const carouselContainer = document.getElementById('video-carousel');
    if (carouselContainer) {
        carouselContainer.addEventListener('touchstart', e => touchStartX = e.changedTouches[0].screenX);
        carouselContainer.addEventListener('touchend', e => {
            touchEndX = e.changedTouches[0].screenX;
            handleSwipe();
        });
    }

    
    function entrypoint() {
        prevButton.addEventListener("click", prevItem);
        nextButton.addEventListener("click", nextItem);
        soundButton.addEventListener("click", toggleSound);
        items.forEach(handleItemEvents);
        loadItem();
    }
    entrypoint();
});